import { HTTP_CP_MortgageCase } from '@api-new/caseservice';
import { HTTP_CP_Mortgage, HTTP_CP_SmartSearch } from '@api-new/mortgageservice';
import { HTTP_CP_Property } from '@api-new/propertyservice';
import { createSelector } from '@ngrx/store';
import { MemoizedSelector } from '@ngrx/store/src/selector';
import { AppState } from '@shared/models/app-state.model';
import { BestBetterDealViewModel } from '@shared/models/best-better-deal-view.model';
import { selectBestBetterDeals } from '@shared/store/best-better-deals/best-better-deals.selectors';
import { selectMortgageCases } from '@shared/store/mortgage-cases/mortgage-cases.selectors';
import { selectMortgages } from '@shared/store/mortgages/mortgages.selectors';
import { selectProperties } from '@shared/store/properties/properties.selectors';
import { selectSmartSearches } from '@shared/store/smart-searches/smart-searches.selectors';
import { PropertiesPortfolioItem } from '../models/properties-portfolio-item.model';
import { selectPortfolioPropertyAdapter } from './adapters/portfolio-property.adapter';
import { selectIsLoadingPortfolio } from './portfolio.selectors';

export const selectPortfolioPropertyList = createSelector(
  selectIsLoadingPortfolio,
  selectProperties,
  selectMortgages,
  selectBestBetterDeals,
  selectMortgageCases,
  selectSmartSearches,
  (
    isLoadingPortfolio: boolean,
    properties: HTTP_CP_Property[],
    mortgages: HTTP_CP_Mortgage[],
    bestBetterDeals: BestBetterDealViewModel[],
    mortgageCases: HTTP_CP_MortgageCase[],
    smartSearches: HTTP_CP_SmartSearch[],
  ): PropertiesPortfolioItem[] => {
    if (isLoadingPortfolio) return [];
    return properties.map((property) => selectPortfolioPropertyAdapter(property, mortgages, bestBetterDeals, mortgageCases, smartSearches));
  },
);

export const selectPortfolioPropertyItem = (propertyId: string): MemoizedSelector<AppState, PropertiesPortfolioItem> =>
  createSelector(selectPortfolioPropertyList, (portfolioPropertyItems: PropertiesPortfolioItem[]): PropertiesPortfolioItem | undefined =>
    portfolioPropertyItems.find((property) => property.property.id === propertyId),
  );
